import { defineStore } from "pinia";

import { amountStatistics, accountInfo } from '@/api'

const useAccountStore = defineStore('account',{
  state:()=>({
    amountData:{}, //金额相关信息
    accountData:{},//认证相关信息
  }),
  actions:{
    async amountStatisticsM(){
      const res = await amountStatistics()
      if(res.code == 0){
        this.amountData = res.data
      }
    },
    async accountInfoM(){
      const res = await accountInfo()
      if(res.code == 0){
        this.accountData = res.data
      }
    }
  }
})

export default useAccountStore